import styled from 'styled-components';

const height = window.innerHeight;

export const StyledMainLayout = styled.div`
	position: relative;
	min-height: ${height}px;
	background-color: ${({ theme }) => theme.bgColors.primary};
`;
